
import {Component, Model, Vue} from 'vue-property-decorator';

@Component({})
export default class VMaskPhone extends Vue {

  @Model()
  private value!: string;
}
